import React from 'react';
import { UrgencyBar } from './UrgencyBar';
import { trackInitiateCheckout } from '../lib/pixel';
export function CTAFinal() {
  return <>
      <UrgencyBar data-id="element-50" />
      <section className="bg-hero-gradient text-center py-[60px] px-5 border-t border-gold" data-id="element-51">
        <div className="max-w-[760px] mx-auto" data-id="element-52">
          <p className="text-xl md:text-[32px] font-black text-white mb-3" data-id="element-53">
            Tu fe merece una <span className="text-gold" data-id="element-54">presencia real</span>{' '}
            en el mundo digital
          </p>
          <p className="text-[15px] text-text-muted mb-8" data-id="element-55">
            Empezá hoy. Acceso inmediato. Garantía 7 días.
          </p>

          <div className="flex flex-wrap justify-center gap-4 mb-6" data-id="element-56">
            <a href="https://www.stockdigital.shop/checkouts/cn/hWNCSin712GXjdX6ppEUlcMk/es-ar?_r=AQABm5guWdJPztfbKHa5RgQhBMMz6LhQ32Hjk18aTGNwW0U&cart_link_id=hFwtJKea&preview_theme_id=140123340859" target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout('esencial')} className="bg-transparent border-2 border-gold text-gold font-black py-4 px-7 text-[14px] rounded-full no-underline transition-transform duration-200 hover:scale-[1.03]" data-id="element-57">
              📘 ESENCIAL — $19.000 ARS
            </a>
            <a href="https://www.stockdigital.shop/checkouts/cn/hWNCShxxet4FE9x7DULjLhv0/es-ar?_r=AQABTkESF8x2q8OAwhm48ooxO9Gou51iDf_nCdpYjYbru68&cart_link_id=Z3eA9310&preview_theme_id=140123340859" target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout('completo')} className="bg-gold-gradient text-base font-black py-4 px-7 text-[14px] rounded-full no-underline transition-transform duration-200 hover:scale-[1.03]" data-id="element-58">
              🏆 COMPLETO — $27.000 ARS
            </a>
          </div>

          <div className="text-[13px] text-[#666] mt-4 flex justify-center flex-wrap gap-4" data-id="element-59">
            <span data-id="element-60">🔒 Pago 100% seguro</span>
            <span data-id="element-61">⚡ Acceso en 5 minutos</span>
            <span data-id="element-62">🛡️ Garantía 7 días</span>
          </div>

          <p className="text-xs text-[#555] mt-3" data-id="element-63">
            Mercado Pago · Tarjeta · Transferencia
          </p>
        </div>
      </section>
    </>;
}